import { Navigate, useLocation, useParams } from "react-router-dom";

import { DEFAULT_LANG } from "@/i18n";

/**
 * KAN-1346 — ``/login`` is the address people guess; the page is
 * ``/sign-in``. The query (``redirect_to``) travels along.
 */
export function LegacySignInRedirect(): JSX.Element {
  const { lang } = useParams<{ lang: string }>();
  const { search } = useLocation();
  return <Navigate to={`/${lang ?? DEFAULT_LANG}/sign-in${search}`} replace />;
}
